declare namespace $ {

	type $mol_text__text_shm_hitalama_map_widget_float_code_panel_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_download__title_shm_hitalama_map_widget_float_code_panel_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_hitalama_map_widget_float_code_panel_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_panel['code_download_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_hitalama_map_widget_float_code_panel_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_panel['code_download_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $mol_select__hint_shm_hitalama_map_widget_float_code_panel_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__trigger_content_shm_hitalama_map_widget_float_code_panel_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_select['trigger_content'] >
	>
	type $mol_select__dictionary_shm_hitalama_map_widget_float_code_panel_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_panel['template_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_select__value_shm_hitalama_map_widget_float_code_panel_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_panel['template_selected'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_check_box__title_shm_hitalama_map_widget_float_code_panel_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_code_panel_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_panel['enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_widget_float_code_panel_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_code_panel_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_code_panel['run_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_map_widget_float_code_panel extends $mol_view {
		panel_content( ): readonly(any)[]
		code_download_blob( ): any
		code_download_file_name( ): string
		Templates_icon( ): $mol_icon_code_braces
		template_dictionary( ): Record<string, any>
		template_selected( next?: string ): string
		enabled( next?: boolean ): boolean
		Run_icon( ): $mol_icon_play
		run_click( next?: any ): any
		no_crdt( ): boolean
		sub( ): ReturnType< $shm_hitalama_map_widget_float_code_panel['panel_content'] >
		No_crdt_label( ): $mol_text
		Download( ): $mol_button_download
		Templates( ): $mol_select
		Autorun_enabled( ): $mol_check_box
		Run( ): $mol_button_minor
	}
	
}

//# sourceMappingURL=panel.view.tree.d.ts.map